import * as React from 'react';

const CameraFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <defs>
            <path
                id="camera-fill_svg__a"
                d="M10 13c-2.205 0-4-1.794-4-4 0-2.205 1.795-4 4-4 2.206 0 4 1.795 4 4 0 2.206-1.794 4-4 4zm4-11V0H6v2H4V0H3v2H0v14h20V2h-6z"
            />
        </defs>
        <g fill="none" fillRule="evenodd" transform="translate(2 4)">
            <mask id="camera-fill_svg__b" fill="#fff">
                <use xlinkHref="#camera-fill_svg__a" />
            </mask>
            <use fill="#45494E" xlinkHref="#camera-fill_svg__a" />
            <g mask="url(#camera-fill_svg__b)">
                <path fill="#000" d="M-2-4h24v24H-2z" />
            </g>
        </g>
    </svg>
);

CameraFillSvg.displayName = 'CameraFillSvg';
export default CameraFillSvg;
